import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Portal } from '@xingternal/portal';
import { PopUpWindowPrimitive } from './pop-up-window.primitive';
import * as Styled from './pop-up-window.styles';
const { dimmerDuration, dimmerTransitionName, popUpWindowDuration, popUpWindowTransitionName, } = Styled;
export const PopUpWindow = ({ children, className, hide, isShown, noPadding, onDimmerClick, ...props }) => {
    const disableScrolling = () => {
        document.body.style.overflow = 'hidden';
    };
    const enableScrolling = () => {
        document.body.style.overflow = 'visible';
    };
    const onKeyDown = (event) => {
        // Close window by pressing ESC
        if (hide && event.keyCode === 27 && isShown) {
            isShown = false;
            hide();
        }
    };
    const onEnter = () => {
        disableScrolling();
        document.addEventListener('keydown', onKeyDown, false);
    };
    const onExited = () => {
        enableScrolling();
        document.removeEventListener('keydown', onKeyDown, false);
    };
    React.useEffect(() => {
        if (isShown) {
            onEnter();
        }
        return () => {
            onExited();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShown]);
    const DimmerTransition = (React.createElement(CSSTransition, { appear: isShown, classNames: dimmerTransitionName, in: isShown, key: "dimmer", mountOnEnter: true, timeout: parseInt(dimmerDuration), unmountOnExit: true },
        React.createElement(Styled.Dimmer, { "data-qa": "pop-up-window-dimmer", "data-testid": "pop-up-window-dimmer", onClick: onDimmerClick })));
    const PopUpWindowTransition = (React.createElement(CSSTransition, { appear: isShown, classNames: popUpWindowTransitionName, in: isShown, key: "popUpWindow", mountOnEnter: true, timeout: parseInt(popUpWindowDuration), unmountOnExit: true },
        React.createElement(PopUpWindowPrimitive, { children: children, noPadding: noPadding, hide: hide })));
    return (React.createElement(React.Fragment, null,
        React.createElement(Portal, null,
            React.createElement(Styled.Wrapper, { "aria-labelledby": "overlay content", "aria-modal": true, className: className, role: "dialog", tabIndex: -1, ...props }, PopUpWindowTransition)),
        DimmerTransition));
};
PopUpWindow.displayName = 'PopUpWindow';
//# sourceMappingURL=pop-up-window.js.map